import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../../base-modal.component';
import { ModalComponent } from '../../../../modal/modal.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'annotate-image-modal',
    templateUrl: 'annotate-modal.component.html',
    styleUrls: ['./annotate-modal.component.scss'],
    standalone: false
})
export class AnnotateModalComponent extends BaseModalPageComponent {
  constructor(public selfModal: ModalComponent, location: Location) {
    super(location);
  }

  public inputObject = null;
  public outputImage: any = null;
  public undoTrigger = new Subject<any>();
  public saveTrigger = new Subject<any>();

  public init(data: any) {
    this.inputObject = {
      annotations: data.annotation || { items: [] },
      svg: data.svg,
      backgroundImage: data.image
    };
  }

  getOutput(outputConfig) {
    this.outputImage = outputConfig;
    this.save();
  }

  save() {
    const anComm = this.outputImage?.annotations?.items
      .filter((x) => x.type === 'number')
      .map((x) => ({
        key: x.data.number,
        description: x.data.description
      }));
    const svgElement = this.outputImage?.svg?.clone(true);
    if (svgElement) {
      svgElement.select('#cTopLeft').remove();
      svgElement.select('#cTopRight').remove();
      svgElement.select('#cBottomRight').remove();
      svgElement.select('#cBottomLeft').remove();
      svgElement.select('image').attr('href', '');
      svgElement.select('g').attr('style', 'cursor: default');
      svgElement.style('transform', `scale(100%)`);
    }
    this.selfModal.close({
      annotation: this.outputImage?.annotations,
      annotationComments: Object.fromEntries(anComm.map((x) => [x.key, x.description])),
      svg: svgElement ? new XMLSerializer().serializeToString(svgElement.node()) : ''
    });
  }

  apply() {
    this.saveTrigger.next(true);
  }

  reset() {
    this.undoTrigger.next(true);
    this.selfModal.close();
  }
}
